import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'default' | 'large';
  href?: string;
  onClick?: () => void;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'default',
  href,
  onClick,
  className = ''
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-lg';
  const variantStyles = {
    primary: 'bg-[rgb(var(--color-secondary))] text-white hover:bg-[rgb(237,110,35)]',
    secondary: 'bg-white text-[rgb(var(--color-primary))] border-2 border-[rgb(var(--color-primary))] hover:bg-[rgb(var(--color-neutral-50))]'
  };
  const sizeStyles = {
    default: 'px-6 py-3 text-base',
    large: 'px-8 py-4 text-lg min-w-[280px]'
  };
  const classes = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  if (href) {
    // Add URL parameters to all Anifit links
    const urlParams = '?new_client_country=NL&category=62183&refconsultant=487050';
    const fullUrl = href + urlParams;
    return <a href={fullUrl} target="_blank" rel="noopener noreferrer" className={classes} data-id="element-344">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={classes} data-id="element-345">
      {children}
    </button>;
}